import { createSelector } from '@ngrx/store';

import { selectDashboardState } from '../dashboard.selectors';
import * as fromInterventionContentItems from './intervention-content-item.reducer';

export const selectInterventionContentItemState = createSelector(
  selectDashboardState,
  (dashboard) => dashboard?.interventionContentItem
);

export const selectIsLoadingInterventionContentItems = createSelector(
  selectInterventionContentItemState,
  (interventionContentItemState) => interventionContentItemState?.loadingInterventionContentItems
);

export const selectInterventionContentItemLoaded = createSelector(
  selectInterventionContentItemState,
  (interventionContentItemState) => interventionContentItemState?.interventionContentItemsLoaded
);

export const selectInterventionContentItems = createSelector(
  selectInterventionContentItemState,
  fromInterventionContentItems.selectAll
);

export const selectContentItemsSortingOrder = createSelector(
  selectInterventionContentItemState,
  (interventionContentItemState) => interventionContentItemState?.contentItemsSortingOrder
);

export const selectSelectedInterventionContentItem = createSelector(
  selectInterventionContentItemState,
  (interventionContentItemState) => interventionContentItemState?.selectedInterventionContentItem
);
